export default __webpack_public_path__ + "static/Iterative-Development-628619e3ab93415a238e0697933e7040.webp";